import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {useState} from '@wordpress/element';
import {  useSelect } from '@wordpress/data';
import {VayuBlocksHeaderTab} from '@vayu-blocks';
import {PanelBody} from '@wordpress/components';
import { VayuBlocksDropShadow,VayuBlockBorderFrame,VayuBlocksColorControl, usePanelSettings } from '@vayu-blocks';
import { useEffect} from 'react';
import {__experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption} from '@wordpress/components';
import { AlignmentMatrixControl } from '@wordpress/components';

const panelKeys = [
    'slide-bg',
    'slide-align',
    'slide-border',
];

const initialPanels = {
    slide: 'slide-bg',
    border: '',
};

const panelOptions = [
    {label: __( 'Background', 'vayu-blocks' ),value: 'slide',icon: 'diamond'},
    {label: __( 'Border', 'vayu-blocks' ),value: 'border',icon: 'slide'}
];

const PanelSettings = ({attributes,setAttributes,isSelected,clientId, handleToggleChange}) => {

    const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

    const [blockValue, setBlockValue] = useState('flip');
    
    const selectedBlock = useSelect(isSelected? (select) => select('core/block-editor').getSelectedBlock(): () => null,[isSelected]);

    useEffect(() => {
        if (!isSelected || selectedBlock?.clientId !== clientId) return;
        const { className } = selectedBlock.attributes || {};
        if (className) {
            const trimmedClassName = className.trim();
            if (trimmedClassName === 'vayu_blocks_flip-box-front') {
                setBlockValue('front');
            } else if (trimmedClassName === 'vayu_blocks_flip-box-back') {
                setBlockValue('back');
            }
        }
    }, [isSelected,selectedBlock]);

    const renderToggleGroup = () => {
        return (
            attributes.parentBlock === 'vayu-blocks/flip-box' && (
                <div className="vayu_blcoks_togglecontrol">
                    <ToggleGroupControl
                        value={blockValue}
                        isBlock
                        __nextHasNoMarginBottom={true}
                        __next40pxDefaultSize={true}
                        onChange={handleToggleChange}
                    >
                        <ToggleGroupControlOption value="front" label="Front" />
                        <ToggleGroupControlOption value="flip" label="Flip Box" />
                        <ToggleGroupControlOption value="back" label="Back" />
                    </ToggleGroupControl>
                </div>
            )
        );
    };

    const tabComponents = {
        slide: (
            <>
                {renderToggleGroup()}

                <PanelBody title={ __( 'Alignment', 'vayu-blocks' ) } opened={openPanels['slide-align']}
                    onToggle={() => onTogglePanel('slide-align')}  className="th-button-panel" >
                        <div className='vb-alignment-matrix-label'>
                            <h6>{__('Alignment', 'vayu-blocks')}</h6>
                            <AlignmentMatrixControl
                                className='vb-alignment-matrix-control'
                                value={ attributes.boxalignment }
                                onChange={ (value) => setAttributes({boxalignment: value})}
                            />
                        </div>
                </PanelBody>

                <PanelBody title={ __( 'Background', 'vayu-blocks' ) } opened={openPanels['slide-bg']}
                    onToggle={() => onTogglePanel('slide-bg')}  className="th-button-panel" >   

                    <VayuBlocksColorControl
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        background={{ value: attributes.flipBackground, backgroundKey: 'flipBackground' }}
                    />  
                            
                </PanelBody>
            </>
        ),
        border: (

            <>
                {renderToggleGroup()}
                
                <PanelBody title={__('Border & Frame', 'vayu-blocks')}  opened={openPanels['slide-border']}
                    onToggle={() => onTogglePanel('slide-border')} >
                    <VayuBlockBorderFrame
                        frameData={attributes.frameData}
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        dataKey="frameData"
                    />
        
                    <br />
        
                    <VayuBlocksDropShadow 
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        dropShadow={{
                            key: 'boxShadow',
                            value: attributes.boxShadow
                        }}
                    />
                </PanelBody>
            </>
        )
    };	

    return (
        
        <>
            {isSelected && (
                <InspectorControls>
                    <div className='th-block-ins th-button-panel'>

                        <VayuBlocksHeaderTab 
                            value={ tab }
                            options={panelOptions}
                            onChange={ setTab }
                        />

                        {tabComponents[tab]}

                    </div>
                </InspectorControls>  
            )}
    
        </>
        
    );
}

export default PanelSettings;